import cn from "classnames";
import * as React from "react";
import styles from "./style.module.less";

interface EmptyPageProps {
    title: string;
    description?: React.ReactNode | string;
    image: JSX.Element;
    panels?: Array<{
        description: React.ReactNode;
        imageSrc: string;
        imageWidth: number;
        imageHeight: number; // Needed to ensure image dimensions are set on page load (to stop the content jumping around as images load).
        imageAlt: string;
    }>;
    learnMore?: React.ReactNode;
}

export const ImageHeight = "7em";

export class EmptyPage extends React.Component<EmptyPageProps, never> {
    render() {
        const props = this.props;
        return (
            <div className={styles.onboardingOuterContainer}>
                <div className={cn(styles.onboardingContainer)}>
                    {props.title && (
                        <div>
                            <h2 className={styles.header}>{props.title}</h2>
                            {props.description && <div className={styles.intro}>{props.description}</div>}
                            {props.learnMore && <div className={styles.learnMore}>{props.learnMore}</div>}
                            {this.props.image}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
